<template>
  <span>
    <form class="row px-0 mx-0">
      <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Nombre</label>
          <input type="text" class="form-control" :value="perfil.nombre+perfil.apellido+credential.codigo" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Dirección:</label>
          <input type="text" class="form-control" value="11751 SW 103RD LN CODE 169" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Ciudad:</label>
          <input type="text" class="form-control" value="MIAMI" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Estado:</label>
          <input type="text" class="form-control" value="Florida" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Código Postal:</label>
          <input type="text" class="form-control" value="33186" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">País:</label>
          <input type="text" class="form-control" value="Estados Unidos" disabled />
        </div>
      </div>
        <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Teléfono:</label>
          <input type="text" class="form-control" value="(202) 977-3377" disabled />
        </div>
      </div>
      
    </form>
  </span>
</template>
<script>
export default {
  props: ["perfil","credential"],
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// DirectionComponent.vue?50727188